import { ApolloError, useMutation } from '@apollo/client'
import { summarizeApolloError } from '@deltek/specification-client/core/Utilities/apolloUtils'
import {
    AddNewContentItem,
    SetProjectContentItemElements,
} from 'api/graphQL/mutations/projectProductFamily.mutations'
import { AddProjectContentItemInputResponse } from 'api/graphQL/types/productFamilyTypes'
import { AddProjectContentItemInputRequest } from 'components/WorkspaceEditor/types'
import { useCallback } from 'react'

export const useProjectContentItemElementsMutation = () => {
    const handleAddItemCompleted = useCallback(<T>(data: T) => {
        // TODO: create a response type
        // - how to handle the response? Should we update the tree data and sync updates to "old workspace"?
    }, [])

    const handleFetchError = useCallback(
        (
            error: ApolloError,
            defaultError: string = 'WorkspaceEditor-projectContentItemElements'
        ) => {
            const summarizedError = summarizeApolloError(error, defaultError)
            console.error(summarizedError)
        },
        []
    )

    const [updateProjectContentItemElement] = useMutation(
        SetProjectContentItemElements(6),
        {
            fetchPolicy: 'no-cache',
            onCompleted: handleAddItemCompleted,
            onError: (error: ApolloError) =>
                handleFetchError(
                    error,
                    'WorkspaceEditor-updateProjectContentItemElement'
                ),
        }
    )

    const [addProjectContentItem] = useMutation<
        AddProjectContentItemInputResponse,
        Partial<AddProjectContentItemInputRequest>
    >(AddNewContentItem(6), {
        fetchPolicy: 'no-cache',
        onCompleted: handleAddItemCompleted,
        onError: (error: ApolloError) =>
            handleFetchError(error, 'WorkspaceEditor-addProjectContentItem'),
    })

    return {
        updateProjectContentItemElement,
        addProjectContentItem,
    }
}
